import { render, staticRenderFns } from "./Role2.vue?vue&type=template&id=392e85ba&scoped=true&"
import script from "./Role2.vue?vue&type=script&lang=js&"
export * from "./Role2.vue?vue&type=script&lang=js&"
import style0 from "./Role2.vue?vue&type=style&index=0&id=392e85ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392e85ba",
  null
  
)

export default component.exports